// easyms organizations actions
import * as ActionTypes from './actionTypes'

export const easyms_fetchOrganizationsRequest = () => ({
    type: ActionTypes.EASYMS_ORGANIZATIONS_FETCH_REQUEST
})

export const easyms_fetchOrganizationsSuccess = data => ({
    type: ActionTypes.EASYMS_ORGANIZATIONS_FETCH_SUCCESS,
    ...data
})

export const easyms_fetchOrganizationsFailure = error => ({
    type: ActionTypes.EASYMS_ORGANIZATIONS_FETCH_FAILURE,
    error
})



// WEBPACK FOOTER //
// ./src/actions/easymsOrganizationsActions.js